import script from "./ClearableInput.vue?vue&type=script&lang=ts&setup=true"
export * from "./ClearableInput.vue?vue&type=script&lang=ts&setup=true"

import "./ClearableInput.vue?vue&type=style&index=0&id=1a8505bf&lang=css"

const __exports__ = script;

export default __exports__